import React from 'react';
import './index.scss';

// 定义组件接收的属性类型
interface BatteryProps {
  percent?: number;
}

// 使用传统函数声明而不是箭头函数，提高兼容性
const Battery = function (props: BatteryProps) {
  // 保留const关键字，但避免使用解构赋值
  const percent = props.percent !== undefined ? props.percent : 100;

  // 根据百分比确定电池颜色 - 使用传统函数声明
  const getBatteryColor = function () {
    if (percent) {
      if (percent <= 20) {
        return '#FC3737'; // 红色
      } else if (percent <= 40) {
        return '#E6A23C'; // 黄色
      } else {
        return '#12B35D'; // 绿色
      }
    }
    // 添加默认返回值，避免undefined
    return '#FC3737';
  };

  // 确保百分比在0-100之间
  const safePercent = Math.max(0, Math.min(100, percent));

  // 获取电池颜色
  const batteryColor = getBatteryColor();

  // 预先创建样式对象，避免内联对象字面量
  const batteryStyle = { borderColor: batteryColor };
  const capStyle = { backgroundColor: batteryColor };
  const powerStyle = {
    width: safePercent + '%',
    backgroundColor: batteryColor
  };

  return (
    <div className="battery" style={batteryStyle}>
      <div className="battery-body"></div>
      <div className="battery-cap" style={capStyle}></div>
      <div className="battery-power" style={powerStyle}></div>
    </div>
  );
};

// 使用React.memo包装组件
export default React.memo(Battery);
